import { Pipe, PipeTransform } from '@angular/core';
import { differenceInCalendarDays, format } from 'date-fns';

@Pipe({
  name: 'todayTimeOrDate',
  standalone: true,
})
export class TodayTimeOrDatePipe implements PipeTransform {
  public transform(value: string | Date, dateFormat = 'dd.MM.yyyy', timeFormat = 'HH:mm:ss'): string {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      value = value.toString();
    }

    const date = Date.parse(value);
    if (isNaN(date)) {
      return value;
    }

    if (differenceInCalendarDays(Date.now(), date) > 0) {
      return format(date, dateFormat);
    } else {
      return format(date, timeFormat);
    }
  }
}
